import { Text } from "@/components/ui/baseUi/text"
import { useDetailedProgramSession } from "@/modules/sessions/hooks/useProgramSessions"
import { SessionDetailsContent } from "@/modules/sessions/sessionDetails/components/sessionDetailsContent"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { word } from "@modules/core/utils/i18n"
import { cn } from "@modules/lib/utils"
import { getMySpacePath } from "@modules/navigation/hooks/useMySpaceNavigate"
import { Path } from "@modules/navigation/routes"
import { useProgram } from "@modules/programs/hooks/usePrograms"
import { ProgramType } from "@modules/programs/types/programTypes"
import { type DetailedSessionType } from "@modules/sessions/sessionsType"
import { Suspense } from "react"

type ProgramSessionDetailsComponentProps = {
  editedSession: DetailedSessionType
  refreshTraining?: () => void
  allowEditContent: boolean
  className?: string
}

export function ProgramSessionDetailsComponent({
  editedSession,
  refreshTraining,
  allowEditContent,
  className,
}: ProgramSessionDetailsComponentProps) {
  const { data: session } = useDetailedProgramSession(
    editedSession.id,
    editedSession.date,
    editedSession.programId,
    editedSession.programType,
  )

  const { data: program } = useProgram(editedSession.programId)

  return (
    <div className={cn("flex w-full grow", className)}>
      {session ? (
        <Suspense fallback={<LoadingSpinner />}>
          <SessionDetailsContent
            session={session}
            programId={editedSession.programId}
            programPath={getMySpacePath(
              program.type === ProgramType.ONOFF
                ? Path.MySpace.ProgramOnOffDetails(program.id)
                : Path.MySpace.ProgramDetails(program.id),
            )}
            allowEditContent={allowEditContent}
            refreshTraining={refreshTraining}
          />
        </Suspense>
      ) : (
        <div className="flex justify-center">
          <Text>{word("global.error.default")}</Text>
        </div>
      )}
    </div>
  )
}
